import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { DynamicField } from "@totalsoft/rocket-ui";
import { decimalPlaces } from "constants/numericLimits";
import { getDynamicFieldProperties } from "utils/functions";
import { onDynamicInputChange } from "utils/propertyChangeAdapters";

const PropertyComponent = ({ idx, item, loadPropertyDetails, onPropertyChange, hasWritePermission }) => (
  <Grid key={item.propertyId} item xs={12} sm={12} md={6}>
    <span id={"property_" + idx + "_property"}></span>
    <DynamicField
      {...getDynamicFieldProperties(item.propertyTypeCode)}
      label={item.propertyName}
      onChange={onDynamicInputChange(onPropertyChange(idx)("propertyValue"))}
      value={item.propertyValue || ""}
      disabled={!hasWritePermission || item.readOnly}
      valueKey={item.propertyTypeCode === "COMBO" ? "value" : undefined}
      labelKey={item.propertyTypeCode === "COMBO" ? "value" : undefined}
      loadOptions={() => loadPropertyDetails(item.propertyId)}
      inputProps={{ decimalScale: item.decimalPlaces ? item.decimalPlaces : decimalPlaces }}
    />
  </Grid>
);

PropertyComponent.propTypes = {
  idx: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  loadPropertyDetails: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  hasWritePermission: PropTypes.bool.isRequired
};

export default PropertyComponent;
